// extracted by css-extract-rspack-plugin
var _1 = "uQa92FZyGNaK-2ZZ03eiWQ--";
export { _1 as "logo" }
